import { NotificationPreference, INotificationPreference } from "./NotificationPreference";
import { NotificationEventSettings, INotificationEventSettings } from "./NotificationEventSettings";
import { OrgNotificationProfile } from "./OrgNotificationProfiles";

export class NotificationSettings implements INotificationSettings {
    AlertCreated:NotificationEventSettings = new NotificationEventSettings();
    AlertClosed:NotificationEventSettings = new NotificationEventSettings();
    TransferIncoming?:NotificationEventSettings = null;
    TransferAccepted?:NotificationEventSettings = null;
    ShareIncoming?:NotificationEventSettings = null;
    ShareAccepted?:NotificationEventSettings = null;
    ShareRejected?:NotificationEventSettings = null;
    ShareRemoved?:NotificationEventSettings = null;
    OrgInviteIncoming?:NotificationEventSettings = null;
    OrgInviteAccepted?:NotificationEventSettings = null;
    OrgInviteRejected?:NotificationEventSettings = null;
    DoorOpened?:NotificationEventSettings = null;
    Dosing?:NotificationEventSettings = null;
    Disconnect?:NotificationEventSettings = null;
    Reconnect?:NotificationEventSettings = null;
    FreezeProtectOn?:NotificationEventSettings = null;
    FreezeProtectOff?:NotificationEventSettings = null;
    // TODO: Add triggers and actions for the following
    ShareExpired?:NotificationEventSettings = null;
    ScheduledHeatingStarted?:NotificationEventSettings = null;
    ScheduledHeatingEnded?:NotificationEventSettings = null;

    public constructor(init?:Partial<INotificationSettings>) {
        for (let prop in init) {
            if (this.hasOwnProperty(prop)) { // returns false without the null initial values
                if (this[prop] instanceof NotificationEventSettings) {
                    this[prop] = new NotificationEventSettings(init[prop]);
                } else {
                    this[prop] = init[prop];
                }
            }
        }
    }
}

export interface INotificationSettings {
    AlertCreated:INotificationEventSettings;
    AlertClosed:INotificationEventSettings;
}

import DefaultUserSettings from './defaults/User.json';
export const UserDefaultNotificationSettings:NotificationSettings = new NotificationSettings(DefaultUserSettings);

import DefaultProfSettings from './defaults/Professional.json';
export const OrgDefaultNotificationSettings:OrgNotificationProfile[] = DefaultProfSettings;